import React from 'react';
import { motion } from 'framer-motion';
import { Wallet, Zap, Scale, Eye, Lock, Ban } from 'lucide-react';
export function BenefitsGrid() {
  const benefits = [{
    title: 'Multi-currency wallets',
    description: 'Hold USD, EUR, GBP, and stablecoins in one place.',
    icon: Wallet
  }, {
    title: 'Fast global transfers',
    description: 'Send money instantly to 180+ countries.',
    icon: Zap
  }, {
    title: 'Stablecoin-powered',
    description: 'Earn yield and settle instantly on-chain.',
    icon: Scale
  }, {
    title: 'Transparent pricing',
    description: 'Real exchange rates with no hidden markups.',
    icon: Eye
  }, {
    title: 'Secure by design',
    description: 'Bank-grade encryption and security protocols.',
    icon: Lock
  }, {
    title: 'No hidden fees',
    description: 'What you see is exactly what you pay.',
    icon: Ban
  }];
  return <section className="py-24 bg-white" data-id="element-137">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16" data-id="element-139">
          {benefits.map((benefit, index) => <motion.div key={benefit.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-start" data-id="element-140">
              <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center text-blue-600 mb-6" data-id="element-141">
                <benefit.icon className="w-6 h-6" data-id="element-142" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2" data-id="element-143">
                {benefit.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-144">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}